import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12 3.25a1.5 1.5 0 0 0-1.5-1.5h-1A1.5 1.5 0 0 0 8 3.25v.714a.5.5 0 0 1-.854.354l-.505-.505a1.5 1.5 0 0 0-2.121 0l-.707.707a1.5 1.5 0 0 0 0 2.121l.505.505A.5.5 0 0 1 3.964 8H3.25a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h.714a.5.5 0 0 1 .354.854l-.505.505a1.5 1.5 0 0 0 0 2.121l.707.707a1.5 1.5 0 0 0 2.121 0l.505-.505a.5.5 0 0 1 .854.353v.715a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-.715a.5.5 0 0 1 .854-.353l.505.505a1.5 1.5 0 0 0 2.121 0l.707-.707a1.5 1.5 0 0 0 0-2.121l-.505-.505a.5.5 0 0 1 .353-.854h.715a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5h-.715a.5.5 0 0 1-.353-.854l.505-.505a1.5 1.5 0 0 0 0-2.121l-.707-.707a1.5 1.5 0 0 0-2.121 0l-.505.505A.5.5 0 0 1 12 3.964V3.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12.75 10a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z"
		})
	]
});
const ForwardRef = forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
